module.exports = __webpack_public_path__ + "d7cc631e006133766434d7c512c57ee5.png";